import { useLoadingStore } from '@/stores/loadingState'

export const useAppLoading = () => {
    const loadingStore = useLoadingStore()
    
    const startInitialLoad = () => {
        loadingStore.setLoading(true, '正在加载华美云...')
        loadingStore.setProgress(0)
        
        // Simulate loading stages
        simulateResourceLoading()
    }
    
    const simulateResourceLoading = () => {
        let progress = 0
        const stages = [
            { text: '正在加载...', duration: 100, target: 25 },
            // { text: '加载应用组件...', duration: 600, target: 50 },
            // { text: '初始化用户认证...', duration: 400, target: 75 },
            // { text: '完成初始化...', duration: 300, target: 100 }
        ]
        
        let currentStage = 0
        
        const loadStage = () => {
            // if (currentStage >= stages.length) {
            //     completeLoading()
            //     return
            // }
            
            const stage = stages[currentStage]
            if(stage){
                loadingStore.setProgress(progress, stage.text)
                const increment = (stage.target - progress) / (stage.duration / 50)
                
                const timer = setInterval(() => {
                    progress += increment
                    loadingStore.setProgress(progress, stage.text)
                    if (progress >= stage.target) {
                        clearInterval(timer)
                        currentStage++
                        setTimeout(loadStage, 100)
                    }
                    
                }, 50)
            }
            
        }
        
        loadStage()
    }
    
    const trackRealLoading = () => {
        // Track actual resource loading
        if (typeof window !== 'undefined') {
            let loadedResources = 0
            let totalResources = 0
            
            // Count total resources
            const images = document.images
            const scripts = document.scripts
            const stylesheets = document.styleSheets
            
            totalResources = images.length + scripts.length + stylesheets.length
            
            const updateProgress = () => {
                loadedResources++
                const progress = (loadedResources / totalResources) * 100
                loadingStore.updateStage('assets', progress)
            }
            
            // Track image loading
            Array.from(images).forEach(img => {
                if (img.complete) {
                    updateProgress()
                } else {
                    img.addEventListener('load', updateProgress)
                    img.addEventListener('error', updateProgress)
                }
            })
            
            // Track when DOM is ready
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => {
                    loadingStore.updateStage('scripts', 100)
                })
            } else {
                loadingStore.updateStage('scripts', 100)
            }
        }
    }
    
    const completeLoading = () => {
        loadingStore.setProgress(100, '加载完成！')
        setTimeout(() => {
            loadingStore.setLoading(false)
        }, 500)
    }
    
    return {
        startInitialLoad,
        trackRealLoading,
        completeLoading
    }
}